import { Role } from 'models'
import { checkRoles } from 'utils'
import { post } from 'services/billing'
import { FineSimulationResult } from 'models/chipCancellation'

export async function simulateCancellation(
  clientId: number,
  itemIds: number[],
  referenceDate: Date
): Promise<FineSimulationResult> {
  await checkRoles([Role.MANAGER, Role.FINANCE])

  const result = await post(
    `/clients/${clientId}/chips/cancellation/simulate`,
    {
      item_ids: itemIds,
      reference_date: referenceDate
    }
  )

  return result.data
}
